import { useAppSelector } from "@/utils";
import { DashboardChecksTypeEnum } from "@payping/api";

// TODO MAKE IT HOOK
export function isPersonalDisable() {
  const checks = useAppSelector((state) => state.user.checks);
  // const personalSectionStatus = Math.min(Number(checks?.personalStatus), Number(checks?.birthCertificateStatus))df;
  const isPersonalDisabled = checks?.personalStatus === DashboardChecksTypeEnum.Confirmed;
  return isPersonalDisabled;
}
